export { default as StateProvider } from "./StateProvider";

import { AppState as TAppState } from "./reducer";
import { AppThunk as TAppThunk } from "./store";

export type AppState = TAppState;
// XXX: Este primise viene por la versión de thunk que trata errores. Cuando se quite, esto tb.
export type AppThunk<R = Promise<void>> = TAppThunk<R>;
